import { render, staticRenderFns } from "./kinh-doanh-doi-item.vue?vue&type=template&id=43c5c660&scoped=true"
import script from "./kinh-doanh-doi-item.vue?vue&type=script&lang=js"
export * from "./kinh-doanh-doi-item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43c5c660",
  null
  
)

export default component.exports